import React from 'react'
import PropTypes from 'prop-types'

const TableWithBackground = ({ children }) => {
  return (
    <div className="relative z-10 flex flex-col gap-3 p-3 rounded-[10px] bg-cream-gray bg-pat01 border-[3px] border-stone-gray">
      {children}
    </div>
  )
}

TableWithBackground.propTypes = {
  children: PropTypes.any
}

export default TableWithBackground
